import React from "react";
import PropTypes from "prop-types";

/**
 * Checkmark icon component for benefits/checklist items.
 */
export const HowItWorksCheckIcon = ({
  className = "tw-w-4 tw-h-4 tw-text-emerald-500 tw-flex-shrink-0 tw-mt-0.5",
  strokeWidth = 1.8,
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M13.3334 4L6.00008 11.3333L2.66675 8"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

HowItWorksCheckIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};

HowItWorksCheckIcon.defaultProps = {
  className: "tw-w-4 tw-h-4 tw-text-emerald-500 tw-flex-shrink-0 tw-mt-0.5",
  strokeWidth: 1.8,
};
